import { render, staticRenderFns } from "./FormItem.vue?vue&type=template&id=bdbb90e2&scoped=true"
import script from "./FormItem.vue?vue&type=script&lang=ts"
export * from "./FormItem.vue?vue&type=script&lang=ts"
import style0 from "./FormItem.vue?vue&type=style&index=0&id=bdbb90e2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbb90e2",
  null
  
)

export default component.exports